import React from 'react';
import { useParams } from 'react-router-dom';
import PageContent from '../../../components/Main/Content/mainContent';
import StockView from '../../../components/Stock/View/stockView';

const EstoqueVisualizar = () => {
  const { id } = useParams();

  return (
    <PageContent>
      <StockView referenceId={id ? Number.parseInt(id, 10) : null} />
    </PageContent>
  );
};

export default EstoqueVisualizar;
